// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/lahso.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/lahso/lahso.js';

mount([g0]);
